var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { RiDeleteBin6Line } from 'react-icons/ri';
import { twMerge } from 'tailwind-merge';
export var DeleteIcon = function (_a) {
    var className = _a.className, onClick = _a.onClick, withoutBg = _a.withoutBg, withoutBorder = _a.withoutBorder;
    return (_jsx("div", __assign({ onClick: onClick, className: twMerge('flex size-[32px] cursor-pointer items-center justify-center rounded-[8px] border border-error', withoutBg ? '' : 'bg-[#F86F6F]/20', withoutBorder ? 'border-none' : '', className) }, { children: _jsx(RiDeleteBin6Line, { className: "size-[20px] text-error" }) })));
};
